
import dayjs from 'dayjs';
require('dayjs/locale/fr');
require('dayjs/locale/es');
require('dayjs/locale/de');
require('dayjs/locale/nl');

export default class I18nDate {
  constructor (lang) {
    this.lang = lang;
    dayjs.locale(lang);
  }

  /**
   * Formate la date en utilisant la langue courante
   * @param {Date|Number} date the original date
   * @param {String} formatStr the string of tokens
   * @param {Object} options an object with options.
   * @returns {String}
   */
  format (date, formatStr = 'PP', options = {}) {
    // Ajoute le paramètre de langue
    return dayjs(date).format(formatStr);
  }

  differenceInDays (start, end) {
    return dayjs(end).diff(start, 'day');
  }

  parseISO (date) {
    return dayjs(date).toDate();
  }

  addDays (date, nbDays) {
    return dayjs(date).add(nbDays, 'day').toDate();
  }
}
